import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./providers/AuthProvider";
import { ConnectionProvider } from "./providers/ConnectionProvider";
import { WebSocketProvider } from "./providers/WebSocketProvider";
import { BotConfigurationProvider } from "./providers/BotConfigurationProvider";
import { AttendantProvider } from "./providers/AttendantProvider";
import { NotificationProvider } from "./providers/NotificationProvider";
import { UpgradeModalProvider } from "./providers/UpgradeModalProvider";
import { AssistantProvider } from "./contexts/AssistantContext";
import { Routes } from "./routes";
import { GoogleOAuthProvider } from "@react-oauth/google";
import NewPlanProvider from "./pages/Finance/Overview/Context/NewPlanProvider";
import { applyTheme } from "./theme";
import "./styles/toast.css";

function App() {
  useEffect(() => {
    // Apply theme on app initialization
    applyTheme();
  }, []);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_APP_ID}>
      <AuthProvider>
        <ConnectionProvider>
          <UpgradeModalProvider>
            <WebSocketProvider>
              <AssistantProvider>
                <BotConfigurationProvider>
                  <AttendantProvider>
                    <NotificationProvider>
                      <NewPlanProvider>
                        <Routes />
                        <Toaster
                          position="top-right"
                          expand={false}
                          richColors
                          closeButton
                        />
                      </NewPlanProvider>
                    </NotificationProvider>
                  </AttendantProvider>
                </BotConfigurationProvider>
              </AssistantProvider>
            </WebSocketProvider>
          </UpgradeModalProvider>
        </ConnectionProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
